import { useState } from "react";
import { Formik } from "formik";

const StepFive = ({step, nextStep, prevStep, handleFormData, values }) => {

    const [counter, setCounter] = useState(1);

    const handleClick = () => {
        setCounter(counter + 1);
    };

	const removeRow = () => {
		setCounter(counter - 1);
	}

    return (
        <div>
            <div className="border-b-2 py-4">
					<div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">{`Step: ${step} of 6`}</div>
					<div className="flex flex-col md:flex-row md:items-center md:justify-between">
						<div className="flex-1">
							<div>
								<div className="text-md font-bold text-gray-800 leading-tight">Sea Service</div>
							</div>
						</div>

						<div className="flex items-center ml-4 md:w-64">
							<div className="w-full bg-white rounded-full mr-2">
								<div className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white" style={{ width: '90%' }}></div>
							</div>
							<div className="text-xs w-10 text-gray-600">90%</div>
						</div>
					</div>
            </div>

			<Formik
			initialValues={{ 
				service_txt1: "",
				service_txt2: "",
				service_txt3: "",
				service_txt4: "",
				service_txt5: "",
				service_txt6: "",
				service_txt7: "",
				service_txt8: "",
				service_txt9: "",
				service_txt10: "",
				service_txt11: "",
				service_txt12: "",
				cargoes_carried: "",
				type_of_cargo: "",
				last_drawn: "",
				expected_wages: ""
			}}
        validate={values => {
            const errors = {};
            return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
            try{	
            handleFormData(values);
            setSubmitting(false);
            nextStep();
            }catch(e){
                console.log(e)
            }
        }}
        >
        {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
        }) => (
	    <form onSubmit={handleSubmit}>
            <div className="py-10">
                <div className="flex flex-col">
					<div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
					    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
						<div className="overflow-hidden">
						<table className="table-auto min-w-full">
							<thead className="py-4 border-b-2 thead-light text-xs">
							<tr>
								<th>Owners/ Manning Agent</th>                            
								<th>Vessel</th>
								<th>Flag</th>
								<th>Type of Vessel</th>
								<th>G.R.T</th>
								<th>Engine Type</th>
								<th>B.H.P</th>
								<th>Rank</th>
								<th>From Date</th>
								<th>To Date</th>
								<th>Total M/D</th>
								<th>Reason for S/OFF</th>
								<th></th>
								</tr>
							</thead>
							<tbody>
                                {Array.from(Array(counter)).map((c, index) => {
                                return (
								<tr className="py-4" key={index}>
								<td>
                                    <input type="text" name={`service_txt1[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt1[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding my-2 border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt2[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt2[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-20"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt3[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt3[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-10"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt4[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt4[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-20"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt5[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt5[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-10"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt6[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt6[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-20"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt7[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt7[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-20"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt8[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt8[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-10"/>
                                </td>
								<td>
                                    <input type="date" name={`service_txt9[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt9[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-24"/>
                                </td>
								<td>
                                    <input type="date" name={`service_txt10[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt10[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-24"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt11[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt11[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-10"/>
                                </td>
								<td>
                                    <input type="text" name={`service_txt12[${index}]`} onChange={handleChange}
											onBlur={handleBlur} value={values.service_txt12[index]} className="form-control px-2 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-gray-500 rounded transition ease-in-out block focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none w-20"/>
                                </td>
								<td><button type="button" onClick={()=> removeRow()} className="text-red-700 font-bold">&times;</button></td>
								</tr>)
                                 })}
							
							</tbody>
							<tfoot>
								<tr>
								<td colspan="12" className="text-right">
								<button type="button" onClick={()=> handleClick()} className="bg-blue-500 hover:bg-blue-400 text-white text-xs font-semibold py-1 px-2 border border-gray-400 rounded shadow">
								Add More
								</button>	
								</td>
								</tr>
							</tfoot>
							</table>
						</div>
						</div>
						</div>
					</div>

					<div className="mb-5">
						<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Cargoes Carried</label>
						<input type="text"
							name='cargoes_carried'
							id='cargoes_carried'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.cargoes_carried}
							className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
							placeholder="Enter Cargoes Carried"/>
					</div>

					<div className="mb-5">
						<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Type of Cargo Cranes perviously worked with</label>
						<input type="text"
							name='type_of_cargo'
							id='type_of_cargo'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.type_of_cargo}
							className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
							placeholder="Enter Type of Cargo Cranes perviously worked with"/>
					</div>

					<div className="mb-5">
						<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Last Drawn Wages</label>
						<input type="text"
							name='last_drawn'
							id='last_drawn'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.last_drawn}
							className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
							placeholder="Enter Last Drawn Wages"/>
					</div>

					<div className="mb-5">
						<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Expected Wages</label>
						<input type="text"
							name='expected_wages'
							id='expected_wages'
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.expected_wages}
							className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
							placeholder="Enter Expected Wages"/>
					</div>
            </div>

            <div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-between">

                    <div className="w-1/2">
						<button
                            onClick={()=> prevStep() }
							className="w-32 focus:outline-none py-2 px-5 rounded-md shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium text-gray-800 text-sm border" 
						>Previous</button>
					</div>

					<div className="w-1/2 text-right">
						<button
							type="submit"
							disabled={isSubmitting}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>Next</button>
					</div>
				</div>
			</div>
            </div>
		</form>)}
		</Formik>
        </div>
    )
}

export default StepFive;